<form [formGroup]="form">
  <div class="gap-lg flex flex-col" formArrayName="aptitudes">
    @for (form of aptitudesForm.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="'Aptitude ' + (idx + 1)" [item]="form" [isOpen]="true">
        <div class="px-lg pt-lg pb-xl gap-lg flex flex-col" [formGroup]="form">
          <div hlmField>
            <label [for]="'aptitude-' + idx" hlmFieldLabel labelRequired>Nom de l'aptitude </label>
            <input [id]="'aptitude-' + idx" hlmInput formControlName="nom" />
            @if (form.get('nom')?.hasError('required') && form.get('nom')?.touched) {
              <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
            }
            @if (form.get('nom')?.hasError('notUnique')) {
              <hlm-field-error>Cette aptitude existe déjà.</hlm-field-error>
            }
          </div>

          <div hlmField>
            <label [for]="'select-phases' + idx" hlmFieldLabel>Rattaché à</label>
            <hlm-select [id]="'select-phases-' + idx" formControlName="phase">
              <hlm-select-trigger>
                <hlm-select-value />
              </hlm-select-trigger>

              <hlm-select-content>
                @for (phase of phases(); track phase.id) {
                  <hlm-option [value]="phase">
                    {{ phase.nom }}
                  </hlm-option>
                }
              </hlm-select-content>
            </hlm-select>
          </div>
        </div>
      </app-expansion-panel>
    }
    @if (estCreation()) {
      <app-button-add-new (click)="addAptitude()" label="Ajouter une aptitude" />
    }
  </div>
</form>
